export default __webpack_public_path__ + "assets/025b11295961287c7c583934f0057bb7.svg";